import * as actions from './auth/actions'
import * as mutations from './auth/mutations'
import * as getters from './auth/getters'

import { menuProperties, authResponseProps } from './auth/properties'

const state = {
    backgrounImage: [
        'https://donquijote.b-cdn.net/birthday-cake-blur-catering-903415.jpg'
    ],
    authModal: {
        currentPathProps: null,
        show: false,
        admin: 0,//0=admin, 1=general user
        title: '',
        target: '',
        targetParameters: []
    },
    showRenewModal: false,
    toggleLogin: true,
    authResponse: JSON.parse(JSON.stringify(authResponseProps)),
    alert: {show: false, message: ''},
    alertBox: {show: false, title: '', message: ''},
    confirmBox: {show: false, title: '', message: '', followingAction: null},
    menus: JSON.parse(JSON.stringify(menuProperties)),
    general: {
        religion: [],
        countries: [],
        relations: []
    },
    commIntegrationWith: [
        { value: 0, name: 'message.newCustomer', 
            variables:['client_name', 'company_name', 'company_address', 'company_contact_info']},
        { value: 1, name: 'message.salesInvoice', 
            variables:['client_name', 'invoice_number', 'invoice_date', 'invoice_total', 'sales_man_name', 
                        'sales_man_contact_info', 'company_name', 'company_address', 'company_contact_info', 'branch_name', 
                        'branch_address', 'branch_contact_info'] },
        { value: 2, name: 'message.salesPayment', 
            variables:['client_name', 'invoice_number', 'invoice_date', 'invoice_total', 'total_paid_amount', 'sales_man_name', 
                        'sales_man_contact_info', 'company_name', 'company_address', 'company_contact_info', 'branch_name', 
                        'branch_address', 'branch_contact_info'] },
        { value: 3, name: 'message.giftCardPurchase', 
            variables:['client_name', 'gift_card_number', 'gift_card_expiry_date', 'gift_amount', 'sales_man_name', 
                        'sales_man_contact_info', 'company_name', 'company_address', 'company_contact_info', 'branch_name', 
                        'branch_address', 'branch_contact_info'] },
        { value: 4, name: 'message.garmentReadyForTrialAlert', 
            variables:['client_name', 'invoice_number', 'invoice_date', 'trial_date', 'sales_man_name', 
                    'sales_man_contact_info', 'company_name', 'company_address', 'company_contact_info', 'branch_name', 
                    'branch_address', 'branch_contact_info'] },
        { value: 5, name: 'message.garmentReadyForDeliveryAlert', 
            variables:['client_name', 'invoice_number', 'invoice_date', 'delivery_date', 'sales_man_name', 
                    'sales_man_contact_info', 'company_name', 'company_address', 'company_contact_info', 'branch_name', 
                    'branch_address', 'branch_contact_info'] },
        { value: 6, name: 'message.garmentDelivered', 
            variables:['client_name', 'invoice_number', 'invoice_date', 'garment_names', 'sales_man_name', 
                'sales_man_contact_info', 'company_name', 'company_address', 'company_contact_info', 'branch_name', 
                'branch_address', 'branch_contact_info'] },
        { value: 7, name: 'message.clientBirthdayWish', 
            variables:['client_name', 'company_name', 'company_address', 'company_contact_info'] },
        { value: 8, name: 'message.clientMarriageAnniversaryWish', 
            variables:['client_name', 'company_name', 'company_address', 'company_contact_info'] },
        { value: 10, name: 'message.clientSignupCode', 
                variables:['client_name', 'company_name', 'company_address', 'company_contact_info', 'signup_code'] },
        { value: 11, name: 'message.clientSignupConfirmation', 
                variables:['client_name', 'company_name', 'company_address', 'company_contact_info'] },
        { value: 12, name: 'message.clientForgotPassword', 
                variables:['client_name', 'company_name', 'company_address', 'company_contact_info', 'new_password'] },
        { value: 9, name: 'message.promotion', 
            variables:[] },
    ],
    reminders: [],
    dashboard: []
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js